import { FC } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { State } from "../../../redux/slices";
import { logoutGrainTrackerE } from "../../../redux/slices/grainTracker/grainTrackerEdition";
import { ConfirmUnsavedChangesDialog } from "../../common/ConfirmUnsavedChangesDialog";
import { useUnsavedChanges } from "../../../hooks/useUnsavedChanges";

const useSetActions = () => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

  return {
    resetEditLocationValues: () => {
      dispatch(logoutGrainTrackerE());
    },
  };
};

const MenuEditLocationPreset: FC = () => {
  const [t] = useTranslation("global");
  const { resetEditLocationValues } = useSetActions();

  const {
    locationSelectedIs,
    principalInfoGT,
    principalInfoGTCopy,
    selectedLocation,
  } = useSelector((state: State) => state.GrainWiseEditionReducer);
  const navigate = useNavigate();
  const managingTitle = () => {
    if (
      locationSelectedIs.EditingValues ||
      locationSelectedIs.EditingStockage
    ) {
      return t("Edit_location.title");
    }
  };

  const { openConfirmDialog, setOpenConfirmDialog } = useUnsavedChanges({
    currentData: principalInfoGT,
    originalData: principalInfoGTCopy,
  });
  const cancel = () => {
    navigate(`/site/details/${selectedLocation.values.name}`);
    setTimeout(() => {
      resetEditLocationValues();
    }, 300);
  };
  const handleCloseClick = () => {
    if (
      JSON.stringify(principalInfoGT) !== JSON.stringify(principalInfoGTCopy)
    ) {
      setOpenConfirmDialog(true);
    } else {
      navigate("/locations");
      setTimeout(() => {
        cancel();
      }, 500);
    }
  };

  const handleConfirmClose = () => {
    setOpenConfirmDialog(false);
    navigate("/locations");
  };

  return (
    <div className="top-options-create-locations">
      <div className="spacer-div-back-button" />
      <div className="create-loc-title"> {managingTitle()}</div>
      <div>
        <Button
          disabled={selectedLocation.loading}
          sx={{
            fontSize: "14px",
            textTransform: "none",
            color: "#232128",
          }}
          variant="text"
          endIcon={<CloseIcon />}
          onClick={handleCloseClick}
        >
          {t("Common_options.Close")}
        </Button>
        <ConfirmUnsavedChangesDialog
          open={openConfirmDialog}
          onClose={() => setOpenConfirmDialog(false)}
          onConfirm={handleConfirmClose}
          t={t}
          confirmButtonLabel="Common_options.Close"
        />
      </div>
    </div>
  );
};

export default MenuEditLocationPreset;
